import {UseCase} from '@s-ui/domain'

class GetScreensetUseCase extends UseCase {
  constructor({service}) {
    super({service})

    this._service = service
  }

  execute({urlVars}) {
    return this._service.execute({urlVars}).then(screensetValueObject => screensetValueObject.toJSON())
  }
}

export default GetScreensetUseCase
